export const BAR_LEVEL = 2
export const CONTENT_LEVEL = BAR_LEVEL - 1
export const SIDEBAR_LEVEL = [BAR_LEVEL + 1, BAR_LEVEL + 1, BAR_LEVEL + 1, BAR_LEVEL - 1]
